/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type CreateManualPaymentRequestType = typeof CreateManualPaymentRequestType[keyof typeof CreateManualPaymentRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateManualPaymentRequestType = {
  booking: 'booking',
  pet_fee: 'pet_fee',
  other: 'other',
  rent: 'rent',
} as const;
